const styles = "@layer crnt.components.tooltip-alternative-dialog {\n\tdialog {\n\t\t&[open] {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t&::backdrop {\n\t\t\tbackground-color: var(--crnt-color-util-scrim);\n\t\t}\n\t}\n}\n";

export { styles as default };
